// ═══════════════════════════════════════════════════════════════════════════
// WRITTN - Firebase Configuration
// ═══════════════════════════════════════════════════════════════════════════
// Your Firebase project configuration
// ═══════════════════════════════════════════════════════════════════════════

import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';

// Firebase configuration for writtn-69312
const firebaseConfig = {
    apiKey: "AIzaSyB7agLlci2t50wd3_CZZ_wacBlt0NUdqLA",
    authDomain: "writtn-69312.firebaseapp.com",
    projectId: "writtn-69312",
    storageBucket: "writtn-69312.firebasestorage.app",
    messagingSenderId: "1067717635908",
    appId: "1:1067717635908:web:d989b758fcc6754a87b111",
    measurementId: "G-M8CP2D0W64"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firebase services
export const auth = getAuth(app);
export const db = getFirestore(app);

export default app;
